<template>
  <div class="layout" style="height: 100vh">
    <Layout>
      <Sider v-bg-color="'#ffffff'" ref="side1" hide-trigger collapsible :collapsed-width="76" v-model="isCollapsed">
        <div style="display: flex; flex-direction: row; align-items: center;">
          <h3 v-line-clamp="1" v-if="!isCollapsed" class="title">{{ title }}</h3>
        </div>
        <Menu active-name="home" theme="light" width="auto" :class="menuitemClasses">
          <MenuItem v-for="(item, i) in menu" :name="item.path" @click="toRouter(item.path)">
          <Icon :type="item.icon"></Icon>
          <span>{{ item.name }}</span>
          </MenuItem>
        </Menu>
      </Sider>
      <Layout>
        <Header :style="{ padding: 0 }" class="layout-header-bar">
          <Icon @click.native="collapsedSider" :class="rotateIcon" :style="{ margin: '0 20px' }" type="md-menu"
            size="24">
          </Icon>
          <span class="ivu-ml-8" v-if="userInfo">
            <Dropdown>
              <a>{{ tip ? tip : '' }}</a>
              <template #list>
                <DropdownMenu>
                  <DropdownItem @click="logOut()">退出登录</DropdownItem>
                </DropdownMenu>
              </template>
            </Dropdown>
          </span>
        </Header>
        <Content class="layout-content" style="margin: 20px; background: #ffffff; padding: 10px;">
          <router-view></router-view>
        </Content>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import menu from '@/menu/menu.js';

export default {
  data() {
    return {
      isCollapsed: false,
      menu: menu,
      tip: null,
      userInfo: null,
      currentPath: '',
      showMenu: false,
      title: "文创上新后台管理",
      width: document.documentElement.clientWidth
    }
  },
  computed: {
    rotateIcon() {
      return [
        'menu-icon',
        this.isCollapsed ? 'rotate-icon' : ''
      ];
    },
    menuitemClasses() {
      return [
        'menu-item',
        this.isCollapsed ? 'collapsed-menu' : ''
      ]
    }
  },
  mounted() {
    let userInfo = this.$store.getters.getUserInfo
    if (userInfo) {
      this.userInfo = userInfo
      this.tip = "欢迎你，" + userInfo.account
      this.showMenu = userInfo.userRole == 1 || userInfo.userRole == 2
      this.menu = menu
    }
    this.currentPath = this.$route.path;
  },
  methods: {
    logOut() {
      this.$store.dispatch('updateUserInfo', null)
      this.$store.dispatch('updateToken', null)
      localStorage.removeItem('token')
      this.$router.replace('/login')
    },
    collapsedSider() {
      this.$refs.side1.toggleCollapse();
    },
    toRouter(path) {
      this.$router.push(path)
    }
  }
}
</script>
<style scoped>
.layout-content {
  overflow-y: auto;
  height: calc(100vh - 100px);
}

.layout {
  background: #f5f7f9;
  position: relative;
  overflow: hidden;
}

.title {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width .2s ease .2s;
  color: #000000;
  padding: 20px 20px;
}

.layout-header-bar {
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
  display: flex;
  flex-direction: row;
  align-items: center;
}

.layout-logo-left {
  width: 90%;
  height: 30px;
  background: #5b6270;
  border-radius: 3px;
  margin: 15px auto;
}

.menu-icon {
  transition: all .3s;
}

.rotate-icon {
  transform: rotate(-90deg);
}

.menu-item span {
  display: inline-block;
  overflow: hidden;
  width: 69px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width .2s ease .2s;
}

.menu-item i {
  transform: translateX(0px);
  transition: font-size .2s ease, transform .2s ease;
  vertical-align: middle;
  font-size: 16px;
}

.collapsed-menu span {
  width: 0px;
  transition: width .2s ease;
}

.collapsed-menu i {
  transform: translateX(5px);
  transition: font-size .2s ease .2s, transform .2s ease .2s;
  vertical-align: middle;
  font-size: 22px;
}
</style>